const n=300,t=50,o=(n,t=300,o=50)=>{const e=null==n?void 0:n.length;return e>t+o?t:e};export{n as DEFAULT_CHAR_LIMIT,t as DEFAULT_CHAR_OFFSET,o as getTruncateSize};
